export const TEAM_CHAT_AVATAR_DEFAULT_SIZE = 32;

export const TEAM_CHAT_AVATAR_BADGE_SIZE = 10;

export const TEAM_CHAT_AVATAR_BADGE_BORDER_WIDTH = 2;

export const TEAM_CHAT_AVATAR_BORDER_WIDTH = 2;

export const TEAM_CHAT_AVATAR_SMALL_THRESHOLD = 28;
